import { ReachAPI } from '../../ReachApi';
import { z } from 'zod';
import { forceTypingPromise, getSecurityIdentity } from '../core';

type PlaceExchange = {
    getCredentials: (security: ReachAPI.Security, widgetId: number) => Promise<{ data: unknown }>;
};

const placeExchangeCredentialsSchema = z.object({
    credentials: z.object({
        token: z.object({
            access_token: z.string(),
            id_token: z.string(),
            expires_in: z.string(),
            token_type: z.literal('Bearer'),
        }),
        adunit_name: z.string().min(1),
    }),
});

const placeExchangeApiResponseSchema = z.object({
    data: placeExchangeCredentialsSchema,
});

/**
 * Gets Token for the place exchange widget
 * @throws {@link ReachApiRetrievalError}
 */
export const getPlaceExchangeCredentials = function (
    widgetId: number
): Promise<z.infer<typeof placeExchangeApiResponseSchema>> {
    return forceTypingPromise(
        placeExchangeApiResponseSchema,
        (ReachAPI.placeexchange as PlaceExchange).getCredentials(getSecurityIdentity(), widgetId)
    );
};
